import UrlBreakoutDisclaimer from './UrlBreakoutDisclaimer';

export default UrlBreakoutDisclaimer;
